import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class OriginHeaderRemoveInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.headers.has('Origin')) {
      request = request.clone({ headers: request.headers.delete('Origin') });
      return next.handle(request);
    }
    return next.handle(request);
  }
}
